export const basePath = `/bff/friendship/`;
